/* eslint-disable */
import { FormInterface } from '@/store'
export default (data: FormInterface) => {
    return JSON.stringify({
        domain: data.platformUrl,
        platform_name: data.platformName,
        email: data.companyMail,
        first_name: data.firstName,
        last_name: data.lastName,
        title: data.jobTitle,
        industry: data.industryOther !== '' ? 'other: ' + data.industryOther : data.industry,
        navigation_color: data.navigationColor,
        navigation_text_color: data.navigationTextColor,
        cta_color: data.callToActionColor,
        active_areas: data.activeAreas,
        password: data.password,
        company_name: data.companyName,
        logo: data.logoUrl,
        cover_image: data.coverImageUrl,
        user_image: data.avatarUrl,
        recaptcha_response: data.recaptchaResponse,
        utm_term: data.utm_term,
        utm_content: data.utm_content,
        utm_campaign: data.utm_campaign,
        utm_medium: data.utm_medium,
        utm_source: data.utm_source,
        region: data.region
    })
}
